import { createFileRoute } from '@tanstack/react-router'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@/lib/auth'
import { parseSessionToken } from '@/lib/window-shim'

/**
 * Profile route configuration.
 *
 * Redirects /profile to the logged-in user's profile page.
 * If not authenticated, redirects to sign-in.
 *
 * @module profile
 * @category Routes
 */
export const Route = createFileRoute('/$locale/profile/')({
  component: ProfileRedirect,
})

/**
 * Redirect component for /profile route.
 *
 * Checks authentication and redirects to the appropriate profile page:
 * - If logged in: redirects to /profile/{userId}
 * - If not logged in: redirects to /signin
 *
 * @returns {null}
 */
function ProfileRedirect() {
  const navigate = useNavigate();
  const rawToken = parseSessionToken();

  if (!rawToken) {
    navigate({ to: '/signin' });
    return null;
  }

  try {
    const parsed = typeof rawToken === 'string' ? JSON.parse(rawToken) : rawToken;
    const accountId = parsed?.account?.id;
    if (accountId) {
      const profileId = typeof accountId === 'string' ? accountId.split(':')[0] : accountId.toString();
      navigate({ to: `/profile/${profileId}` });
    } else {
      navigate({ to: '/signin' });
    }
  } catch (e) {
    console.error('Failed to parse token', e);
    navigate({ to: '/signin' });
  }

  return null;
}

